import {SpecialCategories} from './uploads';
import {defineExpenseOverrides, expenseDataModuleFactory} from '../utils/expense-data';
import Vue from 'vue';

// noinspection JSUnusedGlobalSymbols
const overrides = defineExpenseOverrides({
   state: {
      contractorContracts: {},
      contractorDocsUploadCategoryId: null,
   },

   getters: {
      contractors: (state, getters) => {
         return getters.manualVendors.map((vendor) => ({...vendor}));
      },

      contractorMap: (state, getters) => {
         return getters.contractors.reduce((map, contractor) => {
            map[contractor.id] = contractor;
            return map;
         }, {});
      },

      isComplete: (state, getters) => getters.isCompleted,
      contractorContracts: ({contractorContracts}) => contractorContracts,
      contractorDocsUploadCategoryId: ({contractorDocsUploadCategoryId}) =>
         contractorDocsUploadCategoryId,
   },

   mutations: {
      setContractorDocsUploadCategoryId(state, {uploadCategoryId}) {
         state.contractorDocsUploadCategoryId = uploadCategoryId;
      },

      setContractorContracts(state, {contractorId, files}) {
         Vue.set(state.contractorContracts, contractorId, files);
      },

      clearContractorContracts(state, {contractorId = null} = {}) {
         if (contractorId === null) {
            state.contractorContracts = {};
            return;
         }
         Vue.delete(state.contractorContracts, contractorId);
      },
   },

   actions: {
      async loadContractorDocsUploadCategory({commit, dispatch, state}, {companyId}) {
         if (state.contractorDocsUploadCategoryId !== null) {
            return state.contractorDocsUploadCategoryId;
         }

         const uploadCategory = await dispatch(
            'uploads/loadSpecialCategory',
            {
               companyId,
               category: SpecialCategories.CONTRACTOR_DOCS,
            },
            {root: true}
         );
         commit('setContractorDocsUploadCategoryId', {uploadCategoryId: uploadCategory.id});
         return uploadCategory.id;
      },

      async loadManualVendorDetails({commit}, {vendorId}) {
         const {data} = await this._vm.$http.get(`/api/contractors/vendor/${vendorId}`);
         const source = data?.contractor || data;
         const contractor = {
            ...source,
            name: source.name ?? source.fullname ?? source.fullName ?? null,
            contractType: source.contractType || source.contract_type || null,
            paymentType:
               source.paymentType ||
               source.payment_type ||
               source.contractType ||
               source.contract_type ||
               null,
            contractOptOut: source.contractOptOut ?? source.contract_opt_out ?? false,
            companyIpRights: source.companyIpRights ?? source.company_ip_rights ?? null,
            economicRisk: source.economicRisk ?? source.economic_risk ?? null,
         };

         commit('setManualVendors', contractor);
         return contractor;
      },

      async loadContractFiles({commit}, {contractorId}) {
         const {data} = await this._vm.$http.get(`/api/contractor/${contractorId}/documents`);
         const files = data.results || [];
         commit('setContractorContracts', {
            contractorId,
            files,
         });
         return files;
      },

      async uploadContractFiles(
         {dispatch, state},
         {companyId, contractorId, files, periodId = null}
      ) {
         if (!files || files.length === 0) return [];

         const uploadCategoryId =
            state.contractorDocsUploadCategoryId ||
            (await dispatch('loadContractorDocsUploadCategory', {companyId}));

         await dispatch(
            'uploads/uploadFiles',
            {
               uploadCategoryId,
               files,
               periodId,
               validation: {
                  type: SpecialCategories.CONTRACTOR_DOCS,
                  data: {contractor_id: contractorId},
               },
            },
            {root: true}
         );

         await dispatch('loadContractFiles', {contractorId});
         return state.contractorContracts[contractorId] || [];
      },

      async deleteContractFile({dispatch, state}, {companyId, contractorId, fileId, force = true}) {
         const uploadCategoryId =
            state.contractorDocsUploadCategoryId ||
            (await dispatch('loadContractorDocsUploadCategory', {companyId}));

         await dispatch(
            'uploads/deleteFile',
            {
               fileId,
               uploadCategoryId,
               force,
            },
            {root: true}
         );
         await dispatch('loadContractFiles', {contractorId});
      },
   },
});

export default expenseDataModuleFactory(
   'contractors',
   SpecialCategories.CONTRACTOR_DOCS,
   overrides
);
